import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext.js';
import { ReactComponent as ChevronUpIcon } from 'feather-icons/dist/icons/chevron-up.svg';

const BackToTopButton = styled(motion.button)`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  ${tw`p-4 rounded-full shadow-lg transition-all duration-300 z-50`}
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: white;
  border: none;
  cursor: pointer;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(59, 130, 246, 0.4);
  
  &:hover {
    transform: translateY(-3px) scale(1.1);
    box-shadow: 0 12px 40px rgba(59, 130, 246, 0.6);
    border-color: rgba(255, 255, 255, 0.4);
  }
  
  &:active {
    transform: translateY(-1px) scale(1.05);
  }
  
  svg {
    ${tw`w-6 h-6`}
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }
  
  @media (max-width: 768px) {
    bottom: 1.5rem;
    right: 1.5rem;
    ${tw`p-3`}
    
    svg {
      ${tw`w-5 h-5`}
    }
  }
`;

const BackToTop = () => {
  const { isDarkMode } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <BackToTopButton
      initial={{ opacity: 0, scale: 0 }}
      animate={{ 
        opacity: isVisible ? 1 : 0, 
        scale: isVisible ? 1 : 0,
        y: isVisible ? 0 : 20
      }}
      transition={{ 
        type: "spring", 
        stiffness: 300, 
        damping: 20,
        duration: 0.3
      }}
      onClick={scrollToTop}
      aria-label="Back to top"
      style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
    >
      <ChevronUpIcon />
    </BackToTopButton>
  );
};

export default BackToTop;
